exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-schedule[data-v-8004c314]{display:grid;grid-template-columns:60px 80px 80px 200px 100px 150px 120px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:20px}.day-title[data-v-8004c314]{font-size:14px;font-weight:700}.input-border[data-v-8004c314]{border:1px solid #ccc;border-radius:4px;padding:7px;width:100%;-webkit-box-flex:1;-ms-flex:1;flex:1}input[type=number][data-v-8004c314]{color:#363636}", ""]);

// exports
